import {Component} from "@angular/core";
import {ICellRendererAngularComp} from 'ag-grid-angular';

@Component({
  selector: 'ratio-parent',
  template: `<agratio [value]=value [params]=params></agratio>
            <label class="docNoProgress">{{value}} Days</label>`,
  styles: [`
  agratio {
          height:13px;
          margin: 5px;
          display: block;
          overflow: hidden;
          border: 1px solid $epc-border-light-grey; 
          border-radius: 6px;
          background: $epc-background-color-brown;
      }
    .docNoProgress{
      color:gray;
      text-align:left;
      font-size:10px;
      padding: 0 9px;
      width:100%;
    }
  `]
})
export class RatioParentComponent implements ICellRendererAngularComp {
  public params: any = {};
  value:any={};

  agInit(params: any): void {
      this.params = params;
      this.value = params.value;
  }

  refresh(): boolean {
      return false;
  }
}


// WEBPACK FOOTER //
// ./src/components/agGridRenderer/ratio-parent/ratio-parent.ts